/** Format seconds → mm:ss */
export function fmtTime(sec) {
  if (sec == null || isNaN(sec)) return "--:--";
  sec = Math.max(0, Math.floor(sec));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/** Format KES money */
export function fmtKES(n) {
  if (n == null) return "—";
  return "KES " + Number(n).toLocaleString("en-KE", { maximumFractionDigits: 0 });
}

/** Photo URL builder — public endpoint */
export function photoUrl(path) {
  if (!path) return null;
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/files?path=${encodeURIComponent(path)}`;
}
